import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { APIService } from '../shared/service/api.service';
import { Subscription } from 'rxjs';
import { PagerService } from '../shared/service';

@Component({
  selector: 'app-filtro-instituicoes',
  templateUrl: './filtro-instituicoes.component.html',
  styleUrls: ['./instituicoes-ensino.component.scss']
})
export class FiltroInstituicoesComponent implements OnInit {
  componenteRef = 'filtro-instituicoes';
  instituicoes: any[];
  pageOfItems: Array<any>;
  nomeCurso: string;
  totalResultados: number;
  queryParamsSubscription: Subscription;
  realizouBusca = false;
  error = false;
  ordecao: any;
  filtro: any;
  estadosSelecionados: string;
  municipiosSelecionados: string;
  tipoInstituicaoSelecionados: string;
  stringPesquisa: string;
  pager: any = {};
  pagedItems: any[];

  constructor(private api: APIService,
              private route: ActivatedRoute,
              private pagerService: PagerService) { }

  ngOnInit(): void {
    //  debugger;
    this.route.queryParams.subscribe((q) => {
      this.stringPesquisa = q.query ? q.query : '';
      this.stringPesquisa = q.stringBusca ? q.stringBusca : '';
      this.nomeCurso = q.nomeCurso ? q.nomeCurso : '';
      this.municipiosSelecionados = q.municipiosSelecionados ? q.municipiosSelecionados : [];
      this.estadosSelecionados = q.estadosSelecionados ? q.estadosSelecionados : [];
      this.tipoInstituicaoSelecionados = q.tipoInstituicaoSelecionados ? q.tipoInstituicaoSelecionados : [];
      this.instituicoes = q.instituicoes ? q.instituicoes : [];
    });

    if (this.stringPesquisa) {
      this.getInstituicoesPorNome();
    } else {
      this.pesquisar();
    }
  }

  pesquisar() {
    // debugger;
    this.api.getFiltroInstituicao(this.nomeCurso,
      this.estadosSelecionados,
      this.municipiosSelecionados,
      this.tipoInstituicaoSelecionados).subscribe((instituicoes: any) => {
        this.instituicoes = instituicoes;
        this.setPage(1);
        this.totalResultados = this.instituicoes.length;
      });
  }

  getInstituicoesPorNome() {
    this.api.getInstituicaoPorNome(this.nomeCurso, this.stringPesquisa).subscribe((instituicoes: any) => {
      this.instituicoes = instituicoes;
      this.setPage(1);
      this.totalResultados = this.instituicoes.length;
    });
  }

  recebeuInput(input: string) {
    return null;
  }

  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // pega o objeto pager do serviço
    this.pager = this.pagerService.getPager(this.instituicoes.length, page);
    // pega a página atual de itens
    this.pagedItems = this.instituicoes.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
  }

}
